import * as React from 'react';
/**
 *
 * Original name: phone support
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=51991%3A51
 *
 */
export const PhoneSupportFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M14 4h-4v.687C7.542 5.184 5.938 6.661 5.305 9H4v7h4.5V9H6.662C7.182 7.411 8.289 6.425 10 6.022V6.5h4v-.478c1.71.403 2.817 1.39 3.338 2.978H15.5v7h1.386c-.618 1.026-1.597 1.687-2.944 1.991a1.39 1.39 0 0 0-1.442-.987 1.387 1.387 0 0 0-1.495 1.496 1.389 1.389 0 0 0 1.495 1.495 1.387 1.387 0 0 0 1.285-.642c2.2-.386 3.747-1.53 4.557-3.353H20V9h-1.305C18.062 6.661 16.458 5.184 14 4.687V4Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
